/* tslint:disable */
/* eslint-disable */
/**
 * baseBusinessManage API
 * 関連取引の情報を操作するやつ
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BaseBusinessBulkPutRequest
 */
export interface BaseBusinessBulkPutRequest {
    /**
     * 変更対象IDリスト
     * @type {Array<string>}
     * @memberof BaseBusinessBulkPutRequest
     */
    'targetIds': Array<string>;
    /**
     * 
     * @type {BulkPutBaseBusinessRequestUpdateInfos}
     * @memberof BaseBusinessBulkPutRequest
     */
    'updateInfos': BulkPutBaseBusinessRequestUpdateInfos;
    /**
     * フィールドをNoneにする対象キー
     * @type {Array<string>}
     * @memberof BaseBusinessBulkPutRequest
     */
    'nullKeys'?: Array<string>;
}
/**
 * 関連取引と集計取引の結合情報
 * @export
 * @interface BaseBusinessJoinedAggregateBusiness
 */
export interface BaseBusinessJoinedAggregateBusiness {
    /**
     * 関連取引ID
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'baseBusinessId'?: string;
    /**
     * 置場CD
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'package'?: string;
    /**
     * 単位
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'unit'?: string;
    /**
     * MOQ
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'moq'?: string;
    /**
     * 製造者
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'manufacturer'?: string;
    /**
     * 標準在庫指数（MIN）
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'standardInventoryIndexMin'?: string;
    /**
     * 標準在庫指数（MAX）
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'standardInventoryIndexMax'?: string;
    /**
     * 標準在庫指数（単位）
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'standardInventoryIndexUnit'?: string;
    /**
     * リードタイム
     * @type {number}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'leadTime'?: number;
    /**
     * リードタイム単位
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'leadTimeUnit'?: string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'customerName'?: string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'salesDestinationName'?: string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'endUser'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'salesUnitPrice'?: string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'baseBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 関連取引メモ
     * @type {string}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'baseBusinessNote'?: string;
    /**
     * 作成日時
     * @type {number}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'createAt'?: number;
    /**
     * 更新日時
     * @type {number}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'updateAt'?: number;
    /**
     * 関連取引の自由欄値
     * @type {Array<BusinessFreeColumnValue>}
     * @memberof BaseBusinessJoinedAggregateBusiness
     */
    'businessFreeColumnValues'?: Array<BusinessFreeColumnValue>;
}
/**
 * 
 * @export
 * @interface BaseBusinessMemoBaseBusinessIdPutRequest
 */
export interface BaseBusinessMemoBaseBusinessIdPutRequest {
    /**
     * 
     * @type {BusinessMemoRequestInfo}
     * @memberof BaseBusinessMemoBaseBusinessIdPutRequest
     */
    'baseBusinessMemoInfo': BusinessMemoRequestInfo;
}
/**
 * 
 * @export
 * @interface BaseBusinessPostRequest
 */
export interface BaseBusinessPostRequest {
    /**
     * 
     * @type {PostBaseBusinessRequestInfo}
     * @memberof BaseBusinessPostRequest
     */
    'postBaseBusinessInfo'?: PostBaseBusinessRequestInfo;
}
/**
 * 
 * @export
 * @interface BaseBusinessPutRequest
 */
export interface BaseBusinessPutRequest {
    /**
     * 
     * @type {PutBaseBusinessRequestInfo}
     * @memberof BaseBusinessPutRequest
     */
    'putBaseBusinessRequestInfo': PutBaseBusinessRequestInfo;
}
/**
 * 関連取引担当者取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface BaseBusinessResponsibleUserResponse
 */
export interface BaseBusinessResponsibleUserResponse {
    /**
     * 
     * @type {number}
     * @memberof BaseBusinessResponsibleUserResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof BaseBusinessResponsibleUserResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof BaseBusinessResponsibleUserResponse
     */
    'message': string;
    /**
     * 
     * @type {BaseBusinessResponsibleUserResponseAllOfResult}
     * @memberof BaseBusinessResponsibleUserResponse
     */
    'result': BaseBusinessResponsibleUserResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface BaseBusinessResponsibleUserResponseAllOfResult
 */
export interface BaseBusinessResponsibleUserResponseAllOfResult {
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof BaseBusinessResponsibleUserResponseAllOfResult
     */
    'baseBusinessResponsibleUsers': Array<UserData>;
}
/**
 * 
 * @export
 * @interface BaseBusinessUserIdPutRequest
 */
export interface BaseBusinessUserIdPutRequest {
    /**
     * 更新対象の関連取引ID（複数指定可能）
     * @type {Array<string>}
     * @memberof BaseBusinessUserIdPutRequest
     */
    'targetBusinessIdList': Array<string>;
    /**
     * 更新後の担当者ID
     * @type {Array<string>}
     * @memberof BaseBusinessUserIdPutRequest
     */
    'baseBusinessUserIdList': Array<string>;
}
/**
 * 関連取引一括編集APIのリクエストの型
 * @export
 * @interface BulkPutBaseBusinessRequestUpdateInfos
 */
export interface BulkPutBaseBusinessRequestUpdateInfos {
    /**
     * 
     * @type {string}
     * @memberof BulkPutBaseBusinessRequestUpdateInfos
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutBaseBusinessRequestUpdateInfos
     */
    'customerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutBaseBusinessRequestUpdateInfos
     */
    'salesDestinationNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutBaseBusinessRequestUpdateInfos
     */
    'salesDestinationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutBaseBusinessRequestUpdateInfos
     */
    'endUser'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutBaseBusinessRequestUpdateInfos
     */
    'salesUnitPrice'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkPutBaseBusinessRequestUpdateInfos
     */
    'baseBusinessResponsibleUserIdList'?: Array<string>;
    /**
     * 
     * @type {Array<BusinessFreeColumnValueInput>}
     * @memberof BulkPutBaseBusinessRequestUpdateInfos
     */
    'businessFreeColumnValues'?: Array<BusinessFreeColumnValueInput>;
}
/**
 * 取引自由欄値
 * @export
 * @interface BusinessFreeColumnValue
 */
export interface BusinessFreeColumnValue {
    /**
     * 
     * @type {number}
     * @memberof BusinessFreeColumnValue
     */
    'columnNo': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessFreeColumnValue
     */
    'headerName': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessFreeColumnValue
     */
    'value': string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessFreeColumnValue
     */
    'isMulti': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessFreeColumnValue
     */
    'isConfigured': boolean;
    /**
     * 自由欄の対象（集計取引/関連取引）。columnNo は対象ごとに 1 から採番されるため、未管理登録などで対象を判別する必要がある場合に指定する。
     * @type {string}
     * @memberof BusinessFreeColumnValue
     */
    'target'?: BusinessFreeColumnValueTargetEnum;
}

export const BusinessFreeColumnValueTargetEnum = {
    Aggregate: 'aggregate',
    Base: 'base'
} as const;

export type BusinessFreeColumnValueTargetEnum = typeof BusinessFreeColumnValueTargetEnum[keyof typeof BusinessFreeColumnValueTargetEnum];

/**
 * 取引自由欄値の登録・更新リクエスト用の型
 * @export
 * @interface BusinessFreeColumnValueInput
 */
export interface BusinessFreeColumnValueInput {
    /**
     * 
     * @type {number}
     * @memberof BusinessFreeColumnValueInput
     */
    'columnNo': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessFreeColumnValueInput
     */
    'value': string;
    /**
     * 自由欄の対象（集計取引/関連取引）。columnNo は対象ごとに 1 から採番されるため、未管理登録などで対象を判別する必要がある場合に指定する。
     * @type {string}
     * @memberof BusinessFreeColumnValueInput
     */
    'target'?: BusinessFreeColumnValueInputTargetEnum;
}

export const BusinessFreeColumnValueInputTargetEnum = {
    Aggregate: 'aggregate',
    Base: 'base'
} as const;

export type BusinessFreeColumnValueInputTargetEnum = typeof BusinessFreeColumnValueInputTargetEnum[keyof typeof BusinessFreeColumnValueInputTargetEnum];

/**
 * 取引にメモを追加する際のリクエストの型
 * @export
 * @interface BusinessMemoRequestInfo
 */
export interface BusinessMemoRequestInfo {
    /**
     * 
     * @type {string}
     * @memberof BusinessMemoRequestInfo
     */
    'memoText': string;
}
/**
 * 売上先CD,名取得(マスタから)APIのレスポンスで返ってくるデータの型
 * @export
 * @interface CustomerNameFromMasterResponse
 */
export interface CustomerNameFromMasterResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerNameFromMasterResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerNameFromMasterResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof CustomerNameFromMasterResponse
     */
    'message': string;
    /**
     * 
     * @type {CustomerNameFromMasterResponseAllOfResult}
     * @memberof CustomerNameFromMasterResponse
     */
    'result': CustomerNameFromMasterResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface CustomerNameFromMasterResponseAllOfResult
 */
export interface CustomerNameFromMasterResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerNameFromMasterResponseAllOfResult
     */
    'customerNumbers': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerNameFromMasterResponseAllOfResult
     */
    'customerNames': Array<string>;
}
/**
 * 売上先名取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface CustomerNameResponse
 */
export interface CustomerNameResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof CustomerNameResponse
     */
    'message': string;
    /**
     * 
     * @type {CustomerNameResponseAllOfResult}
     * @memberof CustomerNameResponse
     */
    'result': CustomerNameResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface CustomerNameResponseAllOfResult
 */
export interface CustomerNameResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerNameResponseAllOfResult
     */
    'customerNames': Array<string>;
}
/**
 * 売上先CD取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface CustomerNumberResponse
 */
export interface CustomerNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerNumberResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof CustomerNumberResponse
     */
    'message': string;
    /**
     * 
     * @type {CustomerNumberResponseAllOfResult}
     * @memberof CustomerNumberResponse
     */
    'result': CustomerNumberResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface CustomerNumberResponseAllOfResult
 */
export interface CustomerNumberResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerNumberResponseAllOfResult
     */
    'customerNumbers': Array<string>;
}
/**
 * エンドユーザー取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface EndUserResponse
 */
export interface EndUserResponse {
    /**
     * 
     * @type {number}
     * @memberof EndUserResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof EndUserResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof EndUserResponse
     */
    'message': string;
    /**
     * 
     * @type {EndUserResponseAllOfResult}
     * @memberof EndUserResponse
     */
    'result': EndUserResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface EndUserResponseAllOfResult
 */
export interface EndUserResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof EndUserResponseAllOfResult
     */
    'endUsers': Array<string>;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 受領用内示担当者取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface ForecastForReceiptResponsibleUserResponse
 */
export interface ForecastForReceiptResponsibleUserResponse {
    /**
     * 
     * @type {number}
     * @memberof ForecastForReceiptResponsibleUserResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastForReceiptResponsibleUserResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ForecastForReceiptResponsibleUserResponse
     */
    'message': string;
    /**
     * 
     * @type {ForecastForReceiptResponsibleUserResponseAllOfResult}
     * @memberof ForecastForReceiptResponsibleUserResponse
     */
    'result': ForecastForReceiptResponsibleUserResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface ForecastForReceiptResponsibleUserResponseAllOfResult
 */
export interface ForecastForReceiptResponsibleUserResponseAllOfResult {
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof ForecastForReceiptResponsibleUserResponseAllOfResult
     */
    'forecastForReceiptResponsibleUsers': Array<UserData>;
}
/**
 * 
 * @export
 * @interface GetBaseBusinessFilterItemObjectParameter
 */
export interface GetBaseBusinessFilterItemObjectParameter {
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮したリードタイム情報
     * @type {string}
     * @memberof GetBaseBusinessFilterItemObjectParameter
     */
    'leadTimeInfoList'?: string;
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮した標準在庫指数(min)情報
     * @type {string}
     * @memberof GetBaseBusinessFilterItemObjectParameter
     */
    'stdInventoryIndexMinInfoList'?: string;
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮した標準在庫指数(max)情報
     * @type {string}
     * @memberof GetBaseBusinessFilterItemObjectParameter
     */
    'stdInventoryIndexMaxInfoList'?: string;
}
/**
 * 関連取引情報の取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetBaseBusinessSuccessResponse
 */
export interface GetBaseBusinessSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetBaseBusinessSuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetBaseBusinessSuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetBaseBusinessSuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {GetBaseBusinessSuccessResponseInfo}
     * @memberof GetBaseBusinessSuccessResponse
     */
    'result': GetBaseBusinessSuccessResponseInfo;
}
/**
 * 
 * @export
 * @interface GetBaseBusinessSuccessResponseInfo
 */
export interface GetBaseBusinessSuccessResponseInfo {
    /**
     * 
     * @type {Array<BaseBusinessJoinedAggregateBusiness>}
     * @memberof GetBaseBusinessSuccessResponseInfo
     */
    'data'?: Array<BaseBusinessJoinedAggregateBusiness>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetBaseBusinessSuccessResponseInfo
     */
    'pagingOptions'?: PagingOptions;
}
/**
 * 
 * @export
 * @interface GetFreeColumnValuesResponse
 */
export interface GetFreeColumnValuesResponse {
    /**
     * 
     * @type {number}
     * @memberof GetFreeColumnValuesResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetFreeColumnValuesResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetFreeColumnValuesResponse
     */
    'message': string;
    /**
     * 
     * @type {Array<GetFreeColumnValuesResponseAllOfResult>}
     * @memberof GetFreeColumnValuesResponse
     */
    'result': Array<GetFreeColumnValuesResponseAllOfResult>;
}
/**
 * 
 * @export
 * @interface GetFreeColumnValuesResponseAllOfResult
 */
export interface GetFreeColumnValuesResponseAllOfResult {
    /**
     * 
     * @type {number}
     * @memberof GetFreeColumnValuesResponseAllOfResult
     */
    'columnIndex': number;
    /**
     * 
     * @type {string}
     * @memberof GetFreeColumnValuesResponseAllOfResult
     */
    'headerName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFreeColumnValuesResponseAllOfResult
     */
    'values': Array<string>;
}
/**
 * APIから受け取るpagingOptionsの情報
 * @export
 * @interface PagingOptions
 */
export interface PagingOptions {
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'nextOffset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'totalResultsAvailable': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'returnCount': number;
}
/**
 * 関連取引登録で投げる関連取引情報
 * @export
 * @interface PostBaseBusinessRequestInfo
 */
export interface PostBaseBusinessRequestInfo {
    /**
     * 
     * @type {string}
     * @memberof PostBaseBusinessRequestInfo
     */
    'aggregateBusinessId': string;
    /**
     * 
     * @type {string}
     * @memberof PostBaseBusinessRequestInfo
     */
    'customerName': string;
    /**
     * 
     * @type {string}
     * @memberof PostBaseBusinessRequestInfo
     */
    'customerNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostBaseBusinessRequestInfo
     */
    'salesDestinationName': string;
    /**
     * 
     * @type {string}
     * @memberof PostBaseBusinessRequestInfo
     */
    'salesDestinationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostBaseBusinessRequestInfo
     */
    'endUser'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBaseBusinessRequestInfo
     */
    'forecastForReceiptMemo'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBaseBusinessRequestInfo
     */
    'placeholderFields'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBaseBusinessRequestInfo
     */
    'baseBusinessResponsibleUserIdList': Array<string>;
    /**
     * 
     * @type {Array<BusinessFreeColumnValueInput>}
     * @memberof PostBaseBusinessRequestInfo
     */
    'businessFreeColumnValues'?: Array<BusinessFreeColumnValueInput>;
}
/**
 * postした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface PostBaseBusinessResponse
 */
export interface PostBaseBusinessResponse {
    /**
     * 
     * @type {number}
     * @memberof PostBaseBusinessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostBaseBusinessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostBaseBusinessResponse
     */
    'message': string;
    /**
     * 
     * @type {PostBaseBusinessResponseResult}
     * @memberof PostBaseBusinessResponse
     */
    'result': PostBaseBusinessResponseResult;
}
/**
 * 関連取引登録APIのレスポンスの型定義
 * @export
 * @interface PostBaseBusinessResponseResult
 */
export interface PostBaseBusinessResponseResult {
    /**
     * 
     * @type {string}
     * @memberof PostBaseBusinessResponseResult
     */
    'baseBusinessId': string;
}
/**
 * 関連取引編集APIのリクエストの型
 * @export
 * @interface PutBaseBusinessRequestInfo
 */
export interface PutBaseBusinessRequestInfo {
    /**
     * 
     * @type {string}
     * @memberof PutBaseBusinessRequestInfo
     */
    'baseBusinessId': string;
    /**
     * 
     * @type {string}
     * @memberof PutBaseBusinessRequestInfo
     */
    'customerName': string;
    /**
     * 
     * @type {string}
     * @memberof PutBaseBusinessRequestInfo
     */
    'customerNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutBaseBusinessRequestInfo
     */
    'salesDestinationName': string;
    /**
     * 
     * @type {string}
     * @memberof PutBaseBusinessRequestInfo
     */
    'salesDestinationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutBaseBusinessRequestInfo
     */
    'endUser'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutBaseBusinessRequestInfo
     */
    'salesUnitPrice'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutBaseBusinessRequestInfo
     */
    'baseBusinessResponsibleUserIdList': Array<string>;
    /**
     * 
     * @type {Array<BusinessFreeColumnValueInput>}
     * @memberof PutBaseBusinessRequestInfo
     */
    'businessFreeColumnValues'?: Array<BusinessFreeColumnValueInput>;
}
/**
 * 送り先CD,名取得(マスタから)APIのレスポンスで返ってくるデータの型
 * @export
 * @interface SalesDestinationNameFromMasterResponse
 */
export interface SalesDestinationNameFromMasterResponse {
    /**
     * 
     * @type {number}
     * @memberof SalesDestinationNameFromMasterResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SalesDestinationNameFromMasterResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SalesDestinationNameFromMasterResponse
     */
    'message': string;
    /**
     * 
     * @type {SalesDestinationNameFromMasterResponseAllOfResult}
     * @memberof SalesDestinationNameFromMasterResponse
     */
    'result': SalesDestinationNameFromMasterResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface SalesDestinationNameFromMasterResponseAllOfResult
 */
export interface SalesDestinationNameFromMasterResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesDestinationNameFromMasterResponseAllOfResult
     */
    'salesDestinationNumbers': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesDestinationNameFromMasterResponseAllOfResult
     */
    'salesDestinationNames': Array<string>;
}
/**
 * 送り先名取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface SalesDestinationNameResponse
 */
export interface SalesDestinationNameResponse {
    /**
     * 
     * @type {number}
     * @memberof SalesDestinationNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SalesDestinationNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SalesDestinationNameResponse
     */
    'message': string;
    /**
     * 
     * @type {SalesDestinationNameResponseAllOfResult}
     * @memberof SalesDestinationNameResponse
     */
    'result': SalesDestinationNameResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface SalesDestinationNameResponseAllOfResult
 */
export interface SalesDestinationNameResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesDestinationNameResponseAllOfResult
     */
    'salesDestinationNames': Array<string>;
}
/**
 * 送り先CD取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface SalesDestinationNumberResponse
 */
export interface SalesDestinationNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof SalesDestinationNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SalesDestinationNumberResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SalesDestinationNumberResponse
     */
    'message': string;
    /**
     * 
     * @type {SalesDestinationNumberResponseAllOfResult}
     * @memberof SalesDestinationNumberResponse
     */
    'result': SalesDestinationNumberResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface SalesDestinationNumberResponseAllOfResult
 */
export interface SalesDestinationNumberResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesDestinationNumberResponseAllOfResult
     */
    'salesDestinationNumbers': Array<string>;
}
/**
 * 販売単価取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface SalesUnitPriceResponse
 */
export interface SalesUnitPriceResponse {
    /**
     * 
     * @type {number}
     * @memberof SalesUnitPriceResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SalesUnitPriceResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SalesUnitPriceResponse
     */
    'message': string;
    /**
     * 
     * @type {SalesUnitPriceResponseAllOfResult}
     * @memberof SalesUnitPriceResponse
     */
    'result': SalesUnitPriceResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface SalesUnitPriceResponseAllOfResult
 */
export interface SalesUnitPriceResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesUnitPriceResponseAllOfResult
     */
    'salesUnitPrices': Array<string>;
}
/**
 * ソート種別
 * @export
 * @enum {string}
 */

export const SortType = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortType = typeof SortType[keyof typeof SortType];


/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * リクエストに含めるフィルター項目の型
 * @export
 * @interface UseFilterItem
 */
export interface UseFilterItem {
    /**
     * 置場CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof UseFilterItem
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof UseFilterItem
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof UseFilterItem
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof UseFilterItem
     */
    'package'?: number;
    /**
     * 単位
     * @type {string}
     * @memberof UseFilterItem
     */
    'unit'?: string;
    /**
     * MOQ
     * @type {number}
     * @memberof UseFilterItem
     */
    'moq'?: number;
    /**
     * 製造者
     * @type {string}
     * @memberof UseFilterItem
     */
    'manufacturer'?: string;
    /**
     * 集計取引担当者ID
     * @type {string}
     * @memberof UseFilterItem
     */
    'aggregateBusinessResponsibleUserId'?: string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof UseFilterItem
     */
    'customerName'?: string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof UseFilterItem
     */
    'salesDestinationName'?: string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof UseFilterItem
     */
    'endUser'?: string;
    /**
     * 関連取引担当者ID
     * @type {string}
     * @memberof UseFilterItem
     */
    'baseBusinessResponsibleUserId'?: string;
    /**
     * グループID
     * @type {string}
     * @memberof UseFilterItem
     */
    'groupId'?: string;
}
/**
 * ユーザーデータ
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'name'?: string;
}

/**
 * BaseBusinessApi - axios parameter creator
 * @export
 */
export const BaseBusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 関連取引テーブルの情報を一括変更する
         * @param {BaseBusinessBulkPutRequest} baseBusinessBulkPutRequest 変更する関連取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessBulkPut: async (baseBusinessBulkPutRequest: BaseBusinessBulkPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseBusinessBulkPutRequest' is not null or undefined
            assertParamExists('baseBusinessBulkPut', 'baseBusinessBulkPutRequest', baseBusinessBulkPutRequest)
            const localVarPath = `/base-business/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseBusinessBulkPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 関連テーブルに情報を登録する
         * @param {BaseBusinessPostRequest} baseBusinessPostRequest 登録する関連取引テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessPost: async (baseBusinessPostRequest: BaseBusinessPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseBusinessPostRequest' is not null or undefined
            assertParamExists('baseBusinessPost', 'baseBusinessPostRequest', baseBusinessPostRequest)
            const localVarPath = `/base-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseBusinessPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 関連テーブルに情報を編集する
         * @param {BaseBusinessPutRequest} baseBusinessPutRequest 編集する関連取引テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessPut: async (baseBusinessPutRequest: BaseBusinessPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseBusinessPutRequest' is not null or undefined
            assertParamExists('baseBusinessPut', 'baseBusinessPutRequest', baseBusinessPutRequest)
            const localVarPath = `/base-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseBusinessPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 関連取引情報を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {UseFilterItem} filterItem フィルターの種類
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {GetBaseBusinessFilterItemObjectParameter} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseBusiness: async (sortType: SortType, limit: number, offset: number, filterItem: UseFilterItem, sortTarget?: string, filterItemObject?: GetBaseBusinessFilterItemObjectParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getBaseBusiness', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getBaseBusiness', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getBaseBusiness', 'offset', offset)
            // verify required parameter 'filterItem' is not null or undefined
            assertParamExists('getBaseBusiness', 'filterItem', filterItem)
            const localVarPath = `/base-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sort_target'] = sortTarget;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filterItemObject !== undefined) {
                for (const [key, value] of Object.entries(filterItemObject)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseBusinessApi - functional programming interface
 * @export
 */
export const BaseBusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseBusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 関連取引テーブルの情報を一括変更する
         * @param {BaseBusinessBulkPutRequest} baseBusinessBulkPutRequest 変更する関連取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseBusinessBulkPut(baseBusinessBulkPutRequest: BaseBusinessBulkPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseBusinessBulkPut(baseBusinessBulkPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BaseBusinessApi.baseBusinessBulkPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 関連テーブルに情報を登録する
         * @param {BaseBusinessPostRequest} baseBusinessPostRequest 登録する関連取引テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseBusinessPost(baseBusinessPostRequest: BaseBusinessPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostBaseBusinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseBusinessPost(baseBusinessPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BaseBusinessApi.baseBusinessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 関連テーブルに情報を編集する
         * @param {BaseBusinessPutRequest} baseBusinessPutRequest 編集する関連取引テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseBusinessPut(baseBusinessPutRequest: BaseBusinessPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseBusinessPut(baseBusinessPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BaseBusinessApi.baseBusinessPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 関連取引情報を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {UseFilterItem} filterItem フィルターの種類
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {GetBaseBusinessFilterItemObjectParameter} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBaseBusiness(sortType: SortType, limit: number, offset: number, filterItem: UseFilterItem, sortTarget?: string, filterItemObject?: GetBaseBusinessFilterItemObjectParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBaseBusinessSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBaseBusiness(sortType, limit, offset, filterItem, sortTarget, filterItemObject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BaseBusinessApi.getBaseBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BaseBusinessApi - factory interface
 * @export
 */
export const BaseBusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseBusinessApiFp(configuration)
    return {
        /**
         * 
         * @summary 関連取引テーブルの情報を一括変更する
         * @param {BaseBusinessBulkPutRequest} baseBusinessBulkPutRequest 変更する関連取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessBulkPut(baseBusinessBulkPutRequest: BaseBusinessBulkPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.baseBusinessBulkPut(baseBusinessBulkPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 関連テーブルに情報を登録する
         * @param {BaseBusinessPostRequest} baseBusinessPostRequest 登録する関連取引テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessPost(baseBusinessPostRequest: BaseBusinessPostRequest, options?: any): AxiosPromise<PostBaseBusinessResponse> {
            return localVarFp.baseBusinessPost(baseBusinessPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 関連テーブルに情報を編集する
         * @param {BaseBusinessPutRequest} baseBusinessPutRequest 編集する関連取引テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessPut(baseBusinessPutRequest: BaseBusinessPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.baseBusinessPut(baseBusinessPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 関連取引情報を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {UseFilterItem} filterItem フィルターの種類
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {GetBaseBusinessFilterItemObjectParameter} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseBusiness(sortType: SortType, limit: number, offset: number, filterItem: UseFilterItem, sortTarget?: string, filterItemObject?: GetBaseBusinessFilterItemObjectParameter, options?: any): AxiosPromise<GetBaseBusinessSuccessResponse> {
            return localVarFp.getBaseBusiness(sortType, limit, offset, filterItem, sortTarget, filterItemObject, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseBusinessApi - object-oriented interface
 * @export
 * @class BaseBusinessApi
 * @extends {BaseAPI}
 */
export class BaseBusinessApi extends BaseAPI {
    /**
     * 
     * @summary 関連取引テーブルの情報を一括変更する
     * @param {BaseBusinessBulkPutRequest} baseBusinessBulkPutRequest 変更する関連取引情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBusinessApi
     */
    public baseBusinessBulkPut(baseBusinessBulkPutRequest: BaseBusinessBulkPutRequest, options?: RawAxiosRequestConfig) {
        return BaseBusinessApiFp(this.configuration).baseBusinessBulkPut(baseBusinessBulkPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 関連テーブルに情報を登録する
     * @param {BaseBusinessPostRequest} baseBusinessPostRequest 登録する関連取引テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBusinessApi
     */
    public baseBusinessPost(baseBusinessPostRequest: BaseBusinessPostRequest, options?: RawAxiosRequestConfig) {
        return BaseBusinessApiFp(this.configuration).baseBusinessPost(baseBusinessPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 関連テーブルに情報を編集する
     * @param {BaseBusinessPutRequest} baseBusinessPutRequest 編集する関連取引テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBusinessApi
     */
    public baseBusinessPut(baseBusinessPutRequest: BaseBusinessPutRequest, options?: RawAxiosRequestConfig) {
        return BaseBusinessApiFp(this.configuration).baseBusinessPut(baseBusinessPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 関連取引情報を取得する
     * @param {SortType} sortType ソートの種類（asc/desc）
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {UseFilterItem} filterItem フィルターの種類
     * @param {string} [sortTarget] ソート対象のカラム名
     * @param {GetBaseBusinessFilterItemObjectParameter} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBusinessApi
     */
    public getBaseBusiness(sortType: SortType, limit: number, offset: number, filterItem: UseFilterItem, sortTarget?: string, filterItemObject?: GetBaseBusinessFilterItemObjectParameter, options?: RawAxiosRequestConfig) {
        return BaseBusinessApiFp(this.configuration).getBaseBusiness(sortType, limit, offset, filterItem, sortTarget, filterItemObject, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseBusinessResponsibleUserApi - axios parameter creator
 * @export
 */
export const BaseBusinessResponsibleUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 関連取引担当者一覧を取得する
         * @param {string} [customerNumber] 売上先CD
         * @param {string} [customerName] 売上先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessResponsibleUserGet: async (customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/base-business-responsible-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerNumber !== undefined) {
                localVarQueryParameter['customerNumber'] = customerNumber;
            }

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }

            if (salesDestinationNumber !== undefined) {
                localVarQueryParameter['salesDestinationNumber'] = salesDestinationNumber;
            }

            if (salesDestinationName !== undefined) {
                localVarQueryParameter['salesDestinationName'] = salesDestinationName;
            }

            if (endUser !== undefined) {
                localVarQueryParameter['endUser'] = endUser;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseBusinessResponsibleUserApi - functional programming interface
 * @export
 */
export const BaseBusinessResponsibleUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseBusinessResponsibleUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 関連取引担当者一覧を取得する
         * @param {string} [customerNumber] 売上先CD
         * @param {string} [customerName] 売上先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseBusinessResponsibleUserGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseBusinessResponsibleUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseBusinessResponsibleUserGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, endUser, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BaseBusinessResponsibleUserApi.baseBusinessResponsibleUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BaseBusinessResponsibleUserApi - factory interface
 * @export
 */
export const BaseBusinessResponsibleUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseBusinessResponsibleUserApiFp(configuration)
    return {
        /**
         * 
         * @summary 関連取引担当者一覧を取得する
         * @param {string} [customerNumber] 売上先CD
         * @param {string} [customerName] 売上先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessResponsibleUserGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, keyWord?: string, options?: any): AxiosPromise<BaseBusinessResponsibleUserResponse> {
            return localVarFp.baseBusinessResponsibleUserGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, endUser, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseBusinessResponsibleUserApi - object-oriented interface
 * @export
 * @class BaseBusinessResponsibleUserApi
 * @extends {BaseAPI}
 */
export class BaseBusinessResponsibleUserApi extends BaseAPI {
    /**
     * 
     * @summary 関連取引担当者一覧を取得する
     * @param {string} [customerNumber] 売上先CD
     * @param {string} [customerName] 売上先名
     * @param {string} [salesDestinationNumber] 送り先CD
     * @param {string} [salesDestinationName] 送り先名
     * @param {string} [endUser] エンドユーザー
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBusinessResponsibleUserApi
     */
    public baseBusinessResponsibleUserGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return BaseBusinessResponsibleUserApiFp(this.configuration).baseBusinessResponsibleUserGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, endUser, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseFreeColumnApi - axios parameter creator
 * @export
 */
export const BaseFreeColumnApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 関連取引の自由カラムの値を取得する
         * @param {string} [keyword] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseFreeColumnGet: async (keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/base-free-column`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseFreeColumnApi - functional programming interface
 * @export
 */
export const BaseFreeColumnApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseFreeColumnApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 関連取引の自由カラムの値を取得する
         * @param {string} [keyword] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseFreeColumnGet(keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeColumnValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseFreeColumnGet(keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BaseFreeColumnApi.baseFreeColumnGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BaseFreeColumnApi - factory interface
 * @export
 */
export const BaseFreeColumnApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseFreeColumnApiFp(configuration)
    return {
        /**
         * 
         * @summary 関連取引の自由カラムの値を取得する
         * @param {string} [keyword] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseFreeColumnGet(keyword?: string, options?: any): AxiosPromise<GetFreeColumnValuesResponse> {
            return localVarFp.baseFreeColumnGet(keyword, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseFreeColumnApi - object-oriented interface
 * @export
 * @class BaseFreeColumnApi
 * @extends {BaseAPI}
 */
export class BaseFreeColumnApi extends BaseAPI {
    /**
     * 
     * @summary 関連取引の自由カラムの値を取得する
     * @param {string} [keyword] キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseFreeColumnApi
     */
    public baseFreeColumnGet(keyword?: string, options?: RawAxiosRequestConfig) {
        return BaseFreeColumnApiFp(this.configuration).baseFreeColumnGet(keyword, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BusinessMemoApi - axios parameter creator
 * @export
 */
export const BusinessMemoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 関連テーブルにメモを追加する
         * @param {string} baseBusinessId 関連取引テーブルのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessMemoBaseBusinessIdDelete: async (baseBusinessId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseBusinessId' is not null or undefined
            assertParamExists('baseBusinessMemoBaseBusinessIdDelete', 'baseBusinessId', baseBusinessId)
            const localVarPath = `/base-business-memo/{baseBusinessId}`
                .replace(`{${"baseBusinessId"}}`, encodeURIComponent(String(baseBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 関連テーブルにメモを追加する
         * @param {string} baseBusinessId 関連取引テーブルのID
         * @param {BaseBusinessMemoBaseBusinessIdPutRequest} baseBusinessMemoBaseBusinessIdPutRequest 登録するメモ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessMemoBaseBusinessIdPut: async (baseBusinessId: string, baseBusinessMemoBaseBusinessIdPutRequest: BaseBusinessMemoBaseBusinessIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseBusinessId' is not null or undefined
            assertParamExists('baseBusinessMemoBaseBusinessIdPut', 'baseBusinessId', baseBusinessId)
            // verify required parameter 'baseBusinessMemoBaseBusinessIdPutRequest' is not null or undefined
            assertParamExists('baseBusinessMemoBaseBusinessIdPut', 'baseBusinessMemoBaseBusinessIdPutRequest', baseBusinessMemoBaseBusinessIdPutRequest)
            const localVarPath = `/base-business-memo/{baseBusinessId}`
                .replace(`{${"baseBusinessId"}}`, encodeURIComponent(String(baseBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseBusinessMemoBaseBusinessIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessMemoApi - functional programming interface
 * @export
 */
export const BusinessMemoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessMemoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 関連テーブルにメモを追加する
         * @param {string} baseBusinessId 関連取引テーブルのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseBusinessMemoBaseBusinessIdDelete(baseBusinessId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseBusinessMemoBaseBusinessIdDelete(baseBusinessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessMemoApi.baseBusinessMemoBaseBusinessIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 関連テーブルにメモを追加する
         * @param {string} baseBusinessId 関連取引テーブルのID
         * @param {BaseBusinessMemoBaseBusinessIdPutRequest} baseBusinessMemoBaseBusinessIdPutRequest 登録するメモ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseBusinessMemoBaseBusinessIdPut(baseBusinessId: string, baseBusinessMemoBaseBusinessIdPutRequest: BaseBusinessMemoBaseBusinessIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseBusinessMemoBaseBusinessIdPut(baseBusinessId, baseBusinessMemoBaseBusinessIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessMemoApi.baseBusinessMemoBaseBusinessIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BusinessMemoApi - factory interface
 * @export
 */
export const BusinessMemoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessMemoApiFp(configuration)
    return {
        /**
         * 
         * @summary 関連テーブルにメモを追加する
         * @param {string} baseBusinessId 関連取引テーブルのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessMemoBaseBusinessIdDelete(baseBusinessId: string, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.baseBusinessMemoBaseBusinessIdDelete(baseBusinessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 関連テーブルにメモを追加する
         * @param {string} baseBusinessId 関連取引テーブルのID
         * @param {BaseBusinessMemoBaseBusinessIdPutRequest} baseBusinessMemoBaseBusinessIdPutRequest 登録するメモ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessMemoBaseBusinessIdPut(baseBusinessId: string, baseBusinessMemoBaseBusinessIdPutRequest: BaseBusinessMemoBaseBusinessIdPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.baseBusinessMemoBaseBusinessIdPut(baseBusinessId, baseBusinessMemoBaseBusinessIdPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BusinessMemoApi - object-oriented interface
 * @export
 * @class BusinessMemoApi
 * @extends {BaseAPI}
 */
export class BusinessMemoApi extends BaseAPI {
    /**
     * 
     * @summary 関連テーブルにメモを追加する
     * @param {string} baseBusinessId 関連取引テーブルのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessMemoApi
     */
    public baseBusinessMemoBaseBusinessIdDelete(baseBusinessId: string, options?: RawAxiosRequestConfig) {
        return BusinessMemoApiFp(this.configuration).baseBusinessMemoBaseBusinessIdDelete(baseBusinessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 関連テーブルにメモを追加する
     * @param {string} baseBusinessId 関連取引テーブルのID
     * @param {BaseBusinessMemoBaseBusinessIdPutRequest} baseBusinessMemoBaseBusinessIdPutRequest 登録するメモ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessMemoApi
     */
    public baseBusinessMemoBaseBusinessIdPut(baseBusinessId: string, baseBusinessMemoBaseBusinessIdPutRequest: BaseBusinessMemoBaseBusinessIdPutRequest, options?: RawAxiosRequestConfig) {
        return BusinessMemoApiFp(this.configuration).baseBusinessMemoBaseBusinessIdPut(baseBusinessId, baseBusinessMemoBaseBusinessIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BusinessUserIdApi - axios parameter creator
 * @export
 */
export const BusinessUserIdApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 担当者を更新する
         * @param {BaseBusinessUserIdPutRequest} baseBusinessUserIdPutRequest 更新する担当者情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessUserIdPut: async (baseBusinessUserIdPutRequest: BaseBusinessUserIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseBusinessUserIdPutRequest' is not null or undefined
            assertParamExists('baseBusinessUserIdPut', 'baseBusinessUserIdPutRequest', baseBusinessUserIdPutRequest)
            const localVarPath = `/base-business-user-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseBusinessUserIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessUserIdApi - functional programming interface
 * @export
 */
export const BusinessUserIdApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessUserIdApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 担当者を更新する
         * @param {BaseBusinessUserIdPutRequest} baseBusinessUserIdPutRequest 更新する担当者情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseBusinessUserIdPut(baseBusinessUserIdPutRequest: BaseBusinessUserIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseBusinessUserIdPut(baseBusinessUserIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessUserIdApi.baseBusinessUserIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BusinessUserIdApi - factory interface
 * @export
 */
export const BusinessUserIdApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessUserIdApiFp(configuration)
    return {
        /**
         * 
         * @summary 担当者を更新する
         * @param {BaseBusinessUserIdPutRequest} baseBusinessUserIdPutRequest 更新する担当者情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseBusinessUserIdPut(baseBusinessUserIdPutRequest: BaseBusinessUserIdPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.baseBusinessUserIdPut(baseBusinessUserIdPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BusinessUserIdApi - object-oriented interface
 * @export
 * @class BusinessUserIdApi
 * @extends {BaseAPI}
 */
export class BusinessUserIdApi extends BaseAPI {
    /**
     * 
     * @summary 担当者を更新する
     * @param {BaseBusinessUserIdPutRequest} baseBusinessUserIdPutRequest 更新する担当者情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessUserIdApi
     */
    public baseBusinessUserIdPut(baseBusinessUserIdPutRequest: BaseBusinessUserIdPutRequest, options?: RawAxiosRequestConfig) {
        return BusinessUserIdApiFp(this.configuration).baseBusinessUserIdPut(baseBusinessUserIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerNameApi - axios parameter creator
 * @export
 */
export const CustomerNameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 売上先名一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerNameGet: async (customerNumber?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerNumber !== undefined) {
                localVarQueryParameter['customerNumber'] = customerNumber;
            }

            if (salesDestinationNumber !== undefined) {
                localVarQueryParameter['salesDestinationNumber'] = salesDestinationNumber;
            }

            if (salesDestinationName !== undefined) {
                localVarQueryParameter['salesDestinationName'] = salesDestinationName;
            }

            if (endUser !== undefined) {
                localVarQueryParameter['endUser'] = endUser;
            }

            if (baseBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['baseBusinessResponsibleUserId'] = baseBusinessResponsibleUserId;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerNameApi - functional programming interface
 * @export
 */
export const CustomerNameApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerNameApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 売上先名一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerNameGet(customerNumber?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerNameGet(customerNumber, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerNameApi.customerNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerNameApi - factory interface
 * @export
 */
export const CustomerNameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerNameApiFp(configuration)
    return {
        /**
         * 
         * @summary 売上先名一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerNameGet(customerNumber?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: any): AxiosPromise<CustomerNameResponse> {
            return localVarFp.customerNameGet(customerNumber, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerNameApi - object-oriented interface
 * @export
 * @class CustomerNameApi
 * @extends {BaseAPI}
 */
export class CustomerNameApi extends BaseAPI {
    /**
     * 
     * @summary 売上先名一覧を取得する
     * @param {string} [customerNumber] 客先CD
     * @param {string} [salesDestinationNumber] 送り先CD
     * @param {string} [salesDestinationName] 送り先名
     * @param {string} [endUser] エンドユーザー
     * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerNameApi
     */
    public customerNameGet(customerNumber?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return CustomerNameApiFp(this.configuration).customerNameGet(customerNumber, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerNameFromMasterApi - axios parameter creator
 * @export
 */
export const CustomerNameFromMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 売上先CD,名一覧を取得する (マスタから)
         * @param {string} [customerName] 売上先名
         * @param {string} [customerNumber] 売上先CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerNameFromMasterGet: async (customerName?: string, customerNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-name-from-master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }

            if (customerNumber !== undefined) {
                localVarQueryParameter['customerNumber'] = customerNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerNameFromMasterApi - functional programming interface
 * @export
 */
export const CustomerNameFromMasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerNameFromMasterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 売上先CD,名一覧を取得する (マスタから)
         * @param {string} [customerName] 売上先名
         * @param {string} [customerNumber] 売上先CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerNameFromMasterGet(customerName?: string, customerNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerNameFromMasterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerNameFromMasterGet(customerName, customerNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerNameFromMasterApi.customerNameFromMasterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerNameFromMasterApi - factory interface
 * @export
 */
export const CustomerNameFromMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerNameFromMasterApiFp(configuration)
    return {
        /**
         * 
         * @summary 売上先CD,名一覧を取得する (マスタから)
         * @param {string} [customerName] 売上先名
         * @param {string} [customerNumber] 売上先CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerNameFromMasterGet(customerName?: string, customerNumber?: string, options?: any): AxiosPromise<CustomerNameFromMasterResponse> {
            return localVarFp.customerNameFromMasterGet(customerName, customerNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerNameFromMasterApi - object-oriented interface
 * @export
 * @class CustomerNameFromMasterApi
 * @extends {BaseAPI}
 */
export class CustomerNameFromMasterApi extends BaseAPI {
    /**
     * 
     * @summary 売上先CD,名一覧を取得する (マスタから)
     * @param {string} [customerName] 売上先名
     * @param {string} [customerNumber] 売上先CD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerNameFromMasterApi
     */
    public customerNameFromMasterGet(customerName?: string, customerNumber?: string, options?: RawAxiosRequestConfig) {
        return CustomerNameFromMasterApiFp(this.configuration).customerNameFromMasterGet(customerName, customerNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerNumberApi - axios parameter creator
 * @export
 */
export const CustomerNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 売上先CD一覧を取得する
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerNumberGet: async (customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }

            if (salesDestinationNumber !== undefined) {
                localVarQueryParameter['salesDestinationNumber'] = salesDestinationNumber;
            }

            if (salesDestinationName !== undefined) {
                localVarQueryParameter['salesDestinationName'] = salesDestinationName;
            }

            if (endUser !== undefined) {
                localVarQueryParameter['endUser'] = endUser;
            }

            if (baseBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['baseBusinessResponsibleUserId'] = baseBusinessResponsibleUserId;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerNumberApi - functional programming interface
 * @export
 */
export const CustomerNumberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerNumberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 売上先CD一覧を取得する
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerNumberGet(customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerNumberGet(customerName, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerNumberApi.customerNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerNumberApi - factory interface
 * @export
 */
export const CustomerNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerNumberApiFp(configuration)
    return {
        /**
         * 
         * @summary 売上先CD一覧を取得する
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerNumberGet(customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: any): AxiosPromise<CustomerNumberResponse> {
            return localVarFp.customerNumberGet(customerName, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerNumberApi - object-oriented interface
 * @export
 * @class CustomerNumberApi
 * @extends {BaseAPI}
 */
export class CustomerNumberApi extends BaseAPI {
    /**
     * 
     * @summary 売上先CD一覧を取得する
     * @param {string} [customerName] 客先名
     * @param {string} [salesDestinationNumber] 送り先CD
     * @param {string} [salesDestinationName] 送り先名
     * @param {string} [endUser] エンドユーザー
     * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerNumberApi
     */
    public customerNumberGet(customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return CustomerNumberApiFp(this.configuration).customerNumberGet(customerName, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EndUserApi - axios parameter creator
 * @export
 */
export const EndUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary エンドユーザー一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endUserGet: async (customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/end-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerNumber !== undefined) {
                localVarQueryParameter['customerNumber'] = customerNumber;
            }

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }

            if (salesDestinationNumber !== undefined) {
                localVarQueryParameter['salesDestinationNumber'] = salesDestinationNumber;
            }

            if (salesDestinationName !== undefined) {
                localVarQueryParameter['salesDestinationName'] = salesDestinationName;
            }

            if (baseBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['baseBusinessResponsibleUserId'] = baseBusinessResponsibleUserId;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EndUserApi - functional programming interface
 * @export
 */
export const EndUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EndUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary エンドユーザー一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endUserGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EndUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endUserGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, baseBusinessResponsibleUserId, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndUserApi.endUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EndUserApi - factory interface
 * @export
 */
export const EndUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EndUserApiFp(configuration)
    return {
        /**
         * 
         * @summary エンドユーザー一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endUserGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: any): AxiosPromise<EndUserResponse> {
            return localVarFp.endUserGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EndUserApi - object-oriented interface
 * @export
 * @class EndUserApi
 * @extends {BaseAPI}
 */
export class EndUserApi extends BaseAPI {
    /**
     * 
     * @summary エンドユーザー一覧を取得する
     * @param {string} [customerNumber] 客先CD
     * @param {string} [customerName] 客先名
     * @param {string} [salesDestinationNumber] 送り先CD
     * @param {string} [salesDestinationName] 送り先名
     * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndUserApi
     */
    public endUserGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return EndUserApiFp(this.configuration).endUserGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ForecastForReceiptResponsibleUserApi - axios parameter creator
 * @export
 */
export const ForecastForReceiptResponsibleUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 受領用内示に紐づくユーザー一覧を取得する
         * @param {string} [customerNumber] 売上先CD
         * @param {string} [customerName] 売上先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forecastForReceiptResponsibleUserGet: async (customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/forecast-for-receipt-responsible-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerNumber !== undefined) {
                localVarQueryParameter['customerNumber'] = customerNumber;
            }

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }

            if (salesDestinationNumber !== undefined) {
                localVarQueryParameter['salesDestinationNumber'] = salesDestinationNumber;
            }

            if (salesDestinationName !== undefined) {
                localVarQueryParameter['salesDestinationName'] = salesDestinationName;
            }

            if (endUser !== undefined) {
                localVarQueryParameter['endUser'] = endUser;
            }

            if (baseBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['baseBusinessResponsibleUserId'] = baseBusinessResponsibleUserId;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForecastForReceiptResponsibleUserApi - functional programming interface
 * @export
 */
export const ForecastForReceiptResponsibleUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ForecastForReceiptResponsibleUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 受領用内示に紐づくユーザー一覧を取得する
         * @param {string} [customerNumber] 売上先CD
         * @param {string} [customerName] 売上先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forecastForReceiptResponsibleUserGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForecastForReceiptResponsibleUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forecastForReceiptResponsibleUserGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastForReceiptResponsibleUserApi.forecastForReceiptResponsibleUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ForecastForReceiptResponsibleUserApi - factory interface
 * @export
 */
export const ForecastForReceiptResponsibleUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ForecastForReceiptResponsibleUserApiFp(configuration)
    return {
        /**
         * 
         * @summary 受領用内示に紐づくユーザー一覧を取得する
         * @param {string} [customerNumber] 売上先CD
         * @param {string} [customerName] 売上先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forecastForReceiptResponsibleUserGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: any): AxiosPromise<ForecastForReceiptResponsibleUserResponse> {
            return localVarFp.forecastForReceiptResponsibleUserGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ForecastForReceiptResponsibleUserApi - object-oriented interface
 * @export
 * @class ForecastForReceiptResponsibleUserApi
 * @extends {BaseAPI}
 */
export class ForecastForReceiptResponsibleUserApi extends BaseAPI {
    /**
     * 
     * @summary 受領用内示に紐づくユーザー一覧を取得する
     * @param {string} [customerNumber] 売上先CD
     * @param {string} [customerName] 売上先名
     * @param {string} [salesDestinationNumber] 送り先CD
     * @param {string} [salesDestinationName] 送り先名
     * @param {string} [endUser] エンドユーザー
     * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastForReceiptResponsibleUserApi
     */
    public forecastForReceiptResponsibleUserGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return ForecastForReceiptResponsibleUserApiFp(this.configuration).forecastForReceiptResponsibleUserGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesDestinationNameApi - axios parameter creator
 * @export
 */
export const SalesDestinationNameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 送り先名一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesDestinationNameGet: async (customerNumber?: string, customerName?: string, salesDestinationNumber?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sales-destination-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerNumber !== undefined) {
                localVarQueryParameter['customerNumber'] = customerNumber;
            }

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }

            if (salesDestinationNumber !== undefined) {
                localVarQueryParameter['salesDestinationNumber'] = salesDestinationNumber;
            }

            if (endUser !== undefined) {
                localVarQueryParameter['endUser'] = endUser;
            }

            if (baseBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['baseBusinessResponsibleUserId'] = baseBusinessResponsibleUserId;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesDestinationNameApi - functional programming interface
 * @export
 */
export const SalesDestinationNameApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesDestinationNameApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 送り先名一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesDestinationNameGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesDestinationNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesDestinationNameGet(customerNumber, customerName, salesDestinationNumber, endUser, baseBusinessResponsibleUserId, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesDestinationNameApi.salesDestinationNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesDestinationNameApi - factory interface
 * @export
 */
export const SalesDestinationNameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesDestinationNameApiFp(configuration)
    return {
        /**
         * 
         * @summary 送り先名一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesDestinationNameGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: any): AxiosPromise<SalesDestinationNameResponse> {
            return localVarFp.salesDestinationNameGet(customerNumber, customerName, salesDestinationNumber, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesDestinationNameApi - object-oriented interface
 * @export
 * @class SalesDestinationNameApi
 * @extends {BaseAPI}
 */
export class SalesDestinationNameApi extends BaseAPI {
    /**
     * 
     * @summary 送り先名一覧を取得する
     * @param {string} [customerNumber] 客先CD
     * @param {string} [customerName] 客先名
     * @param {string} [salesDestinationNumber] 送り先CD
     * @param {string} [endUser] エンドユーザー
     * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesDestinationNameApi
     */
    public salesDestinationNameGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return SalesDestinationNameApiFp(this.configuration).salesDestinationNameGet(customerNumber, customerName, salesDestinationNumber, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesDestinationNameFromMasterApi - axios parameter creator
 * @export
 */
export const SalesDestinationNameFromMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 送り先CD,名一覧を取得する (マスタから)
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesDestinationNameFromMasterGet: async (salesDestinationName?: string, salesDestinationNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sales-destination-name-from-master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (salesDestinationName !== undefined) {
                localVarQueryParameter['salesDestinationName'] = salesDestinationName;
            }

            if (salesDestinationNumber !== undefined) {
                localVarQueryParameter['salesDestinationNumber'] = salesDestinationNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesDestinationNameFromMasterApi - functional programming interface
 * @export
 */
export const SalesDestinationNameFromMasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesDestinationNameFromMasterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 送り先CD,名一覧を取得する (マスタから)
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesDestinationNameFromMasterGet(salesDestinationName?: string, salesDestinationNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesDestinationNameFromMasterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesDestinationNameFromMasterGet(salesDestinationName, salesDestinationNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesDestinationNameFromMasterApi.salesDestinationNameFromMasterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesDestinationNameFromMasterApi - factory interface
 * @export
 */
export const SalesDestinationNameFromMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesDestinationNameFromMasterApiFp(configuration)
    return {
        /**
         * 
         * @summary 送り先CD,名一覧を取得する (マスタから)
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesDestinationNameFromMasterGet(salesDestinationName?: string, salesDestinationNumber?: string, options?: any): AxiosPromise<SalesDestinationNameFromMasterResponse> {
            return localVarFp.salesDestinationNameFromMasterGet(salesDestinationName, salesDestinationNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesDestinationNameFromMasterApi - object-oriented interface
 * @export
 * @class SalesDestinationNameFromMasterApi
 * @extends {BaseAPI}
 */
export class SalesDestinationNameFromMasterApi extends BaseAPI {
    /**
     * 
     * @summary 送り先CD,名一覧を取得する (マスタから)
     * @param {string} [salesDestinationName] 送り先名
     * @param {string} [salesDestinationNumber] 送り先CD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesDestinationNameFromMasterApi
     */
    public salesDestinationNameFromMasterGet(salesDestinationName?: string, salesDestinationNumber?: string, options?: RawAxiosRequestConfig) {
        return SalesDestinationNameFromMasterApiFp(this.configuration).salesDestinationNameFromMasterGet(salesDestinationName, salesDestinationNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesDestinationNumberApi - axios parameter creator
 * @export
 */
export const SalesDestinationNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 送り先CD一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesDestinationNumberGet: async (customerNumber?: string, customerName?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sales-destination-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerNumber !== undefined) {
                localVarQueryParameter['customerNumber'] = customerNumber;
            }

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }

            if (salesDestinationName !== undefined) {
                localVarQueryParameter['salesDestinationName'] = salesDestinationName;
            }

            if (endUser !== undefined) {
                localVarQueryParameter['endUser'] = endUser;
            }

            if (baseBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['baseBusinessResponsibleUserId'] = baseBusinessResponsibleUserId;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesDestinationNumberApi - functional programming interface
 * @export
 */
export const SalesDestinationNumberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesDestinationNumberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 送り先CD一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesDestinationNumberGet(customerNumber?: string, customerName?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesDestinationNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesDestinationNumberGet(customerNumber, customerName, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesDestinationNumberApi.salesDestinationNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesDestinationNumberApi - factory interface
 * @export
 */
export const SalesDestinationNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesDestinationNumberApiFp(configuration)
    return {
        /**
         * 
         * @summary 送り先CD一覧を取得する
         * @param {string} [customerNumber] 客先CD
         * @param {string} [customerName] 客先名
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesDestinationNumberGet(customerNumber?: string, customerName?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: any): AxiosPromise<SalesDestinationNumberResponse> {
            return localVarFp.salesDestinationNumberGet(customerNumber, customerName, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesDestinationNumberApi - object-oriented interface
 * @export
 * @class SalesDestinationNumberApi
 * @extends {BaseAPI}
 */
export class SalesDestinationNumberApi extends BaseAPI {
    /**
     * 
     * @summary 送り先CD一覧を取得する
     * @param {string} [customerNumber] 客先CD
     * @param {string} [customerName] 客先名
     * @param {string} [salesDestinationName] 送り先名
     * @param {string} [endUser] エンドユーザー
     * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesDestinationNumberApi
     */
    public salesDestinationNumberGet(customerNumber?: string, customerName?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return SalesDestinationNumberApiFp(this.configuration).salesDestinationNumberGet(customerNumber, customerName, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesUnitPriceApi - axios parameter creator
 * @export
 */
export const SalesUnitPriceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 販売単価一覧を取得する
         * @param {string} [customerNumber] 売上先CD
         * @param {string} [customerName] 売上先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesUnitPriceGet: async (customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sales-unit-price`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerNumber !== undefined) {
                localVarQueryParameter['customerNumber'] = customerNumber;
            }

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }

            if (salesDestinationNumber !== undefined) {
                localVarQueryParameter['salesDestinationNumber'] = salesDestinationNumber;
            }

            if (salesDestinationName !== undefined) {
                localVarQueryParameter['salesDestinationName'] = salesDestinationName;
            }

            if (endUser !== undefined) {
                localVarQueryParameter['endUser'] = endUser;
            }

            if (baseBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['baseBusinessResponsibleUserId'] = baseBusinessResponsibleUserId;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesUnitPriceApi - functional programming interface
 * @export
 */
export const SalesUnitPriceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesUnitPriceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 販売単価一覧を取得する
         * @param {string} [customerNumber] 売上先CD
         * @param {string} [customerName] 売上先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesUnitPriceGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesUnitPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesUnitPriceGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesUnitPriceApi.salesUnitPriceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesUnitPriceApi - factory interface
 * @export
 */
export const SalesUnitPriceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesUnitPriceApiFp(configuration)
    return {
        /**
         * 
         * @summary 販売単価一覧を取得する
         * @param {string} [customerNumber] 売上先CD
         * @param {string} [customerName] 売上先名
         * @param {string} [salesDestinationNumber] 送り先CD
         * @param {string} [salesDestinationName] 送り先名
         * @param {string} [endUser] エンドユーザー
         * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesUnitPriceGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: any): AxiosPromise<SalesUnitPriceResponse> {
            return localVarFp.salesUnitPriceGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesUnitPriceApi - object-oriented interface
 * @export
 * @class SalesUnitPriceApi
 * @extends {BaseAPI}
 */
export class SalesUnitPriceApi extends BaseAPI {
    /**
     * 
     * @summary 販売単価一覧を取得する
     * @param {string} [customerNumber] 売上先CD
     * @param {string} [customerName] 売上先名
     * @param {string} [salesDestinationNumber] 送り先CD
     * @param {string} [salesDestinationName] 送り先名
     * @param {string} [endUser] エンドユーザー
     * @param {string} [baseBusinessResponsibleUserId] 関連取引担当者ID
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesUnitPriceApi
     */
    public salesUnitPriceGet(customerNumber?: string, customerName?: string, salesDestinationNumber?: string, salesDestinationName?: string, endUser?: string, baseBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return SalesUnitPriceApiFp(this.configuration).salesUnitPriceGet(customerNumber, customerName, salesDestinationNumber, salesDestinationName, endUser, baseBusinessResponsibleUserId, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



